import { render, staticRenderFns } from "./select.vue?vue&type=template&id=5ad84eb5&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"
import style0 from "./select.vue?vue&type=style&index=0&id=5ad84eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad84eb5",
  null
  
)

export default component.exports